import {Assets} from "@/app/utils/assets";
import {useTranslation} from "react-i18next";
import styles from "./styles.module.scss";
import Space, {spaceSizes} from "@/app/components/Space";
import {FirstTitleText, SubheadText} from "@/app/components/texts";
import {s} from "@/app/utils/s";
import Image from "@/app/components/image";
import React from "react";

interface EmptyPageProps {
  asset?: string;
  title?: string;
  subtitle?: string;
}

const EmptyPage: React.FC<EmptyPageProps> = ({
                                               asset = Assets.empty,
                                               title,
                                               subtitle,
                                             }) => {
  const {t} = useTranslation();
  const defaultTitle = t(s.noResults);
  const defaultSubtitle = t(s.tryChangingTheRequest);

  return (
    <div className={styles.emptyPage}>
      <Image className={styles.image} asset={asset}/>
      <Space h={spaceSizes.s12}/>
      <FirstTitleText text={title || defaultTitle} className={styles.title}/>
      <Space h={spaceSizes.s12}/>
      <SubheadText text={subtitle || defaultSubtitle}/>
    </div>
  );
};

export default EmptyPage;